import styled from "styled-components";

import { motion } from "@enkor/framer-motion";

import { grayScale, getOpacityColor, pink } from "@enkor/design/colors";
import { APP_SIZE } from "@styles/variables";
import { getColorButtonAnimation } from "@domains/common/utils/animationHelper";

export const BUTTON_BOX = {
  BUTTON_HEIGHT: 48,
  PADDING: 16,
};

export const ACTIVE_BUTTON_ANIMATION = getColorButtonAnimation({
  hoverColor: pink[300],
  tapColor: pink[200],
});

export const BottomButtonBox = styled.div<{ $shouldFixSafeArea?: boolean }>`
  position: fixed;
  bottom: 0;
  left: 50%;

  width: 100%;
  max-width: ${APP_SIZE.MAX_WIDTH}px;
  height: auto;
  margin-top: auto;
  padding: ${BUTTON_BOX.PADDING}px;

  padding-bottom: ${({ $shouldFixSafeArea }) =>
    $shouldFixSafeArea ? BUTTON_BOX.PADDING : "env(safe-area-inset-bottom)"};

  border-top: 1px solid ${grayScale.main};

  background: ${getOpacityColor(grayScale[200], 0.7)};

  transform: translateX(-50%);
  -webkit-backdrop-filter: blur(4px);
  backdrop-filter: blur(4px);
`;

export const ButtonGroupWrapper = styled.div`
  display: flex;
  gap: 9px;

  width: 100%;
  height: ${BUTTON_BOX.BUTTON_HEIGHT}px;
`;

export const ShareButtonBox = styled(motion.button)`
  padding: 12px;
  border-radius: 8px;

  svg {
    pointer-events: none;
  }
`;

const StyledButton = styled(motion.button)<{
  $bgColor?: string;
  $textColor?: string;
  $borderColor?: string;
}>`
  width: 100%;
  padding: 13px 16px;
  border: 1px solid ${({ $borderColor }) => $borderColor || "transparent"};
  border-radius: 8px;

  background-color: ${({ $bgColor }) => $bgColor || pink.main};

  color: ${({ $textColor }) => $textColor || grayScale.white};
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
`;

export const FullButton = styled(StyledButton)`
  display: flex;
  justify-content: center;
  align-items: center;

  &:disabled {
    background-color: ${grayScale.main};

    color: ${grayScale[500]};

    cursor: not-allowed;
  }
`;

export const AdditionalButton = styled(StyledButton)`
  max-width: 110px;
  padding: 13px 16px;
  border-radius: 8px;

  background: ${getOpacityColor(grayScale.white, 0.15)};
`;
